import script from "./AdminOrderManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOrderManage.vue?vue&type=script&setup=true&lang=js"

import "./AdminOrderManage.vue?vue&type=style&index=0&id=f2762d60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2762d60"]])

export default __exports__